import React from "react";
import { ReactComponent as IbicareLogo } from "../assets/images/SATI/ibicare-logo.svg";
import "../pages/Onboarding/onboarding.scss";

export function OnboardingLayout({ children }) {
  return (
    <div className="onboarding-shell">
      <header className="onboarding-header">
        <div className="onboarding-brand" aria-label="IBICARE">
          <IbicareLogo role="img" aria-label="IBICARE" />
        </div>
      </header>

      <main className="onboarding-main">
        <div className="onboarding-intro">
          <h1>Completa tu ficha de salud</h1>
          <p>
            Accede con el correo que tu empresa te proporcionó.
          </p>
        </div>
        <section className="onboarding-card" aria-label="Recorrido de onboarding">
          {children}
        </section>
        <aside className="onboarding-privacy-note">
          <span className="onboarding-privacy-icon" aria-hidden="true">i</span>
          <p>
            Tus respuestas se conservan en esta pestaña hasta confirmar el
            envío. Si la cierras antes, podrás iniciar sesión y consultar el
            estado de tu ficha de nuevo.
          </p>
        </aside>
      </main>

      <footer className="onboarding-footer">
        IBICARE
      </footer>
    </div>
  );
}

export default OnboardingLayout;
